export default class MobileMegaMenu {
  constructor() {
    this.container = document.querySelector('.mobileMenu')
    this.openSubmenuButtons = this.container?.querySelectorAll('.mobileSubmenu-parent > a')
    this.closeSubmenuButtons = this.container?.querySelectorAll('.closeSubmenuButton')

    const hamburgerButtons = document.querySelectorAll('.toggle')
    hamburgerButtons.forEach((toggleButton) => {
      toggleButton.addEventListener('click', () => {
        this.container.querySelectorAll('.mobileSubmenu-parent').forEach((el) => {
          el.classList.remove('open')
        })
      })
    })

    this.handleSubmenuButtons()
  }

  handleSubmenuButtons() {
    this.openSubmenuButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        this.toggleSubmenu(button, 'add')
      })
    })

    this.closeSubmenuButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.preventDefault()
        this.toggleSubmenu(button, 'remove')
      })
    })
  }

  toggleSubmenu(button, action) {
    const parent = button?.closest('.mobileSubmenu-parent')
    parent?.classList[action]('open')
  }
}
